import styled from 'styled-components';
import { StyledGridRow } from 'ui/indexPages/tables/grid';
import { spacing } from 'ui/theme';

export const GridRow = styled(StyledGridRow)`
    gap: 0;

    > div {
        padding-left: ${spacing.base} !important;
        padding-right: ${spacing.base} !important;
    }

    > div:first-child {
        padding-left: 0 !important;
    }

    > div:last-child {
        padding-right: 0 !important;
    }
`;
